module.exports = __webpack_public_path__ + "assets/82cd3a722274ef0649b79a00ed5828bf.mp3";